let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d42tP")).then(() => parcelRequire('2VQWj'));